import { Component } from '@angular/core';

@Component({
  selector: 'app-carbonscore-modal-fr',
  templateUrl: './carbonscore-modal-fr.component.html',
  styleUrls: ['./carbonscore-modal-fr.component.scss'],
  standalone: false,
})
export class CarbonscoreModalFrComponent {
  constructor() {}
}
